import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  Container,
  Typography,
  Box,
  Button,
  TextField,
  Paper,
  Divider,
  Alert,
} from "@mui/material";
import EmailUpdate from "./EmailUpdate";
import PasswordUpdate from "./PasswordUpdate";
import ProfileImageUpdate from "./ProfileImageUpdate";
import { auth } from "../../services/firebase/config";
import { updateProfile } from "firebase/auth";
import { updateUserProfile } from "../../services/firebase/database";

function EditProfile() {
  const user = useSelector((state) => state.auth.user);
  const navigate = useNavigate();
  const [name, setName] = useState(user?.displayName || "");
  const [nameUpdateStatus, setNameUpdateStatus] = useState(null);

  useEffect(() => {
    setName(user?.displayName || "");
  }, [user]);

  const handleNameUpdate = async () => {
    setNameUpdateStatus(null);
    if (!user) {
      setNameUpdateStatus({ type: "error", message: "User not logged in." });
      return;
    }
    if (name.trim() === "") {
      setNameUpdateStatus({ type: "error", message: "Name cannot be empty." });
      return;
    }

    try {
      // Update Firebase Auth profile
      await updateProfile(auth.currentUser, {
        displayName: name,
      });

      // Update Firestore user document
      await updateUserProfile(user.uid, { name: name });

      setNameUpdateStatus({ type: "success", message: "Name updated successfully!" });
    } catch (error) {
      console.error("Error updating name:", error);
      setNameUpdateStatus({ type: "error", message: error.message });
    }
  };
  
  return (
    <Container maxWidth="md" sx={{ mt: 6 }}>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Typography variant="h4" sx={{ mb: 4 }}>
          Edit Profile
        </Typography>

        <Box sx={{ mb: 4 }}>
          <Typography variant="h6" sx={{ mb: 2 }}>
            Name
          </Typography>
          <TextField
            fullWidth
            label="Display Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            sx={{ mb: 2 }}
          />
          <Button variant="contained" onClick={handleNameUpdate}>
            Save Name
          </Button>
          {nameUpdateStatus && (
            <Alert severity={nameUpdateStatus.type} sx={{ mt: 2 }}>
              {nameUpdateStatus.message}
            </Alert>
          )}
        </Box>
        
        <Divider sx={{ my: 3 }} />
        
        <Box sx={{ mb: 4 }}>
          <Typography variant="h6" sx={{ mb: 2 }}>
            Profile Image
          </Typography>
          <ProfileImageUpdate
            userId={user.uid}
            onImageUpdate={() => {}}
          />
        </Box>
        
        <Divider sx={{ my: 3 }} />
        
        <Box sx={{ mb: 4 }}>
          <Typography variant="h6" sx={{ mb: 2 }}>
            Email Address
          </Typography>
          <EmailUpdate currentEmail={user.email} userId={user.uid} />
        </Box>
        
        <Divider sx={{ my: 3 }} />
        
        <Box sx={{ mb: 4 }}>
          <Typography variant="h6" sx={{ mb: 2 }}>
            Password
          </Typography>
          <PasswordUpdate />
        </Box>
        
        <Button 
          variant="outlined" 
          onClick={() => navigate('/profile')}
          sx={{ mt: 2 }}
        >
          Back to Profile
        </Button>
      </Paper>
    </Container>
  );
}

export default EditProfile;